"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekViewDnD = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_dnd_1 = require("react-dnd");
var luxon_1 = require("luxon");
var clsx_1 = __importDefault(require("clsx"));
var CONTAINER_STYLES = "overflow-hidden absolute inset-0";
var RECT_STYLES = "absolute inset-y-0 h-full bg-lochivar-dark bg-opacity-20 border-2 border-lochivar-default";
var WeekViewDnD = function (_a) {
    var _b, _c;
    var startDate = _a.startDate, accept = _a.accept, onDrop = _a.onDrop, onDropHover = _a.onDropHover;
    var actualStart = luxon_1.DateTime.fromISO(startDate, { zone: "utc" }).startOf("day");
    var elRef = (0, react_1.useRef)(null);
    var _d = (0, react_1.useState)(null), dropDate = _d[0], setDropDate = _d[1];
    var handleDrop = (0, react_1.useCallback)(function (itemType, item) {
        if (dropDate) {
            onDrop === null || onDrop === void 0 ? void 0 : onDrop(itemType, item, dropDate);
        }
    }, [onDrop, dropDate]);
    var handleDropHover = (0, react_1.useCallback)(function (itemType, item) {
        if (dropDate) {
            onDropHover === null || onDropHover === void 0 ? void 0 : onDropHover(itemType, item, dropDate);
        }
    }, [onDropHover, dropDate]);
    var rectWidth = ((_c = (_b = elRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) !== null && _c !== void 0 ? _c : 100) / 7;
    var _e = (0, react_dnd_1.useDrop)(function () { return ({
        accept: accept,
        collect: function (monitor) { return ({
            isOver: monitor.isOver(),
            itemType: monitor.getItemType(),
        }); },
        drop: function (item, monitor) {
            handleDrop(monitor.getItemType(), item);
        },
        hover: function (item, monitor) {
            var _a, _b, _c, _d;
            var _e = item, uuid = _e.uuid, type = _e.type, calendarId = _e.calendarId, start = _e.start, end = _e.end;
            if (monitor.canDrop()) {
                var x = ((_b = (_a = monitor.getClientOffset()) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : 0) -
                    ((_d = (_c = elRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().x) !== null && _d !== void 0 ? _d : 0);
                var index = Math.floor(x / rectWidth);
                setDropDate(actualStart.plus({ days: index }).toISO());
                handleDropHover === null || handleDropHover === void 0 ? void 0 : handleDropHover(monitor.getItemType(), {
                    uuid: uuid,
                    calendarId: calendarId,
                    type: type,
                    start: start,
                    end: end,
                });
            }
        },
    }); }, [handleDrop, handleDropHover, setDropDate, dropDate, elRef, actualStart]), _f = _e[0], isOver = _f.isOver, itemType = _f.itemType, drop = _e[1];
    (0, react_1.useEffect)(function () {
        if (!isOver && dropDate) {
            setDropDate(null);
        }
    }, [dropDate, setDropDate, isOver]);
    drop(elRef);
    var diffDays = Math.floor(dropDate
        ? luxon_1.DateTime.fromISO(dropDate, { zone: "utc" }).diff(actualStart, "days")
            .days
        : 0);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)(CONTAINER_STYLES, itemType ? "pointer-events-auto" : "pointer-events-none"), ref: elRef }, { children: dropDate && isOver ? ((0, jsx_runtime_1.jsx)("div", { className: RECT_STYLES, style: {
                left: rectWidth * diffDays,
                width: rectWidth,
            } }, void 0)) : null }), void 0));
};
exports.WeekViewDnD = WeekViewDnD;
